import { format, isValid } from 'date-fns';

export function getClockTime(dateStr: string): string {
    const date = new Date(dateStr);
    if (!isValid(date)) {
        return 'Invalid Date';
    }
    return format(new Date(dateStr), 'HH:mm');
}
